<template>
    <button style="display:none;" type="button" class="btn btn-primary" data-bs-toggle="modal"
                                data-bs-target="#mdlInfoModal" id="btnAbrirInfoModal">Open</button>
    <div class="modal fade" id="mdlInfoModal" tabindex="-1" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ modal.title }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div v-if="modal.body == 'Construction'">
                        <h5 class="modspec_font14">Qualify for a discount</h5>

                    <p class="modspec_font10">We can apply a discount to any project if Modspec has previously reviewed the proposed building design or calculated the proposed construction details and this information is stored on our system. You can also add your proposed construction to our system, and this data will be stored for use on future projects, reducing lead-times and assessment costs. It may be sensible to do this if you plan on using this construction option in more than one project.</p>

                    <h5 class="modspec_font14">Information Required</h5>
                    <div class="modspec_font12">
                        <p>For each project we require the following information:</p>
                        <ul class="no-bullets">
                            <li>Proposed construction details for roof, ceilings, walls & floors.</li>
                            <li>Structural framing details including; spacing (ctr distances), framing material & dimensions (i.e C15019 steel joists @ 400ctrs).</li>
                            <li>Details of sarking, insulated foil or bulk insulation for all envelope fabrics. </li>
                            <li>Detail of any thermal breaks and application. </li>
                            <li>Window schedule, including proposed glazing U-value & SHGC. </li>
                            <li>Reflected Ceiling plan to show eave and shading projections. </li>
                        </ul>
                        <br/>
                        <p>Note, most information is gathered from the drawings you provide. Please ensure the drawings uploaded include the information as itemised above.</p>
                    </div>
                    </div>
                    <div v-if="modal.body == 'Drawings'">
                    <div class="modspec_font12">
                        <p>For each project we require the following information:</p>
                      <ul>
                        <li>Proposed construction details for roof, ceilings, walls & floors.</li>
                        <li>Structural framing details including; spacing (ctr distances), framing material & dimensions (i.e C15019 steel joists @ 400ctrs).</li>
                        <li>Details of sarking, insulated foil or bulk insulation for all envelope fabrics.</li>
                        <li>Detail of any thermal breaks and application.</li>
                        <li>Window schedule, including proposed glazing U-value & SHGC.</li>
                        <li>Reflected Ceiling plan to show eave and shading projections.</li>
                      </ul>
                      <p>Note, most information is gathered from the drawings you provide. Please ensure the drawings uploaded include the information as itemised above.</p>
                    </div>
                    </div>
                    <div v-else>
                        <p class="modspec_font12">{{ modal.body }}</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "info-modal",
    props: ['info'],
    data: function () {
        return {
            modal:{title:'', body:''}
        }
    },
    watch: {
        info: function (newVal, oldVal) {
            console.log(newVal,oldVal);
            this.showInformation(newVal)
        }
    },
    methods: {
        showInformation(t) {
            console.log("mostrar info",t)
            this.modal.title = t.title;
            this.modal.body = t.body;
            document.getElementById('btnAbrirInfoModal').click();

            //investigando para abrir sin boton (no funciona el cierre)
            /*let elemDiv = document.createElement('div');
            elemDiv.classList.add("modal-backdrop");
            elemDiv.classList.add("fade");
            elemDiv.classList.add("show");
            document.body.appendChild(elemDiv);


            let mdl = document.getElementById('mdlInfoModal');
            mdl.style.cssText = "display:block";
            mdl.classList.add("show");*/
        },
    }
}
</script>

<style scoped>
ul.no-bullets {
  list-style-type: none; /* Remove bullets */
  padding: 0; /* Remove padding */
  margin: 0; /* Remove margins */
}
</style>